(function () {
  var theme = (window.theme = window.theme || {});
  var DRAWER_SECTION_ID = 'cart-drawer';
  var $ = window.jQuery;
  var lastFocus = null;
  var visibilityRevision = 0;
  var noteTimer = null;
  var pendingNote = null;
  var noteRevision = 0;
  var checkoutPending = false;
  var pendingOffers = new Set();
  var cartReviewRequired = false;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + path;
  }

  function showCartNotice(message, options) {
    var drawer = getDrawer();
    if (!drawer) return;
    var notice = drawer.querySelector('[data-cart-status]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-cart-status', '');
      notice.setAttribute('role', 'status');
      getPanel().prepend(notice);
    }
    notice.textContent = message + ' ';
    var link = document.createElement('a');
    link.href = route('cart');
    link.textContent = 'View cart';
    notice.appendChild(link);
    if (!options || options.open !== false) open();
  }

  var controller = window.FatheadCartController.create({
    fetch: function (url, options) { return fetch(url, options); },
    route: route,
    render: function (data, context) {
      return renderCart({ sections: data.sections, cart: data, open: context.open,
        source: context.source, restoreFocus: context.restoreFocus, visibilityRevision: context.visibilityRevision });
    },
    emit: function (detail) {
      if (detail.outcome === 'unknown') cartReviewRequired = true;
      document.dispatchEvent(new CustomEvent('fathead:cart:operation', { detail: detail }));
    },
    onRenderError: function () {
      cartReviewRequired = true;
      var drawer = getDrawer();
      if (drawer) drawer.querySelectorAll('.cart-drawer__item').forEach(function (item) { setItemLoading(item, false); });
      showCartNotice('Your cart was updated, but the drawer could not refresh.');
    }
  });

  var quantityEdits = window.FatheadCartPendingEdits.create({
    save: saveQuantity,
    onError: function (error) { showCartNotice(error.description || error.message); }
  });

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getPanel() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('.cart-drawer__panel') : null;
  }

  function isOpen() {
    var drawer = getDrawer();
    return !!(drawer && drawer.classList.contains('is-active'));
  }

  function headerSectionId() {
    var el = document.querySelector('.header-cart');
    if (!el) return null;
    var section = el.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace(/^shopify-section-/, '');
  }

  function sectionIds() {
    var ids = [DRAWER_SECTION_ID];
    var headerId = headerSectionId();
    if (headerId) ids.push(headerId);
    return ids.join(',');
  }

  function ensureOnBody() {
    var drawer = getDrawer();
    if (drawer && drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function focusable(container) {
    if (!container) return [];
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return el.offsetParent !== null && !el.hasAttribute('disabled');
      });
  }

  var backgroundState = new Map();
  var backgroundObserver = null;
  function isolateBackground() {
    var drawer = getDrawer();
    Array.prototype.forEach.call(document.body.children, function (element) {
      if (element === drawer || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
      if (!backgroundState.has(element)) backgroundState.set(element, element.inert);
      element.inert = true;
    });
    if (!backgroundObserver) {
      backgroundObserver = new MutationObserver(isolateBackground);
      backgroundObserver.observe(document.body, { childList: true });
    }
  }

  function restoreBackground() {
    if (backgroundObserver) backgroundObserver.disconnect();
    backgroundObserver = null;
    backgroundState.forEach(function (inert, element) { element.inert = inert; });
    backgroundState.clear();
  }

  function applyOpenState(opts) {
    opts = opts || {};
    var drawer = getDrawer();
    var panel = getPanel();
    if (!drawer || !panel) return;
    ensureOnBody();
    drawer.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    isolateBackground();
    if (opts.focus !== false) panel.focus();
  }

  // Remember which control had focus before a re-render so we can put it back.
  function focusSnapshot() {
    var active = document.activeElement;
    var drawer = getDrawer();
    if (!active || !drawer || !drawer.contains(active)) return null;
    var key = active.getAttribute('data-line-key');
    var selector = null;
    if (active.matches('.cart-drawer__qty-input')) selector = '.cart-drawer__qty-input';
    else if (active.matches('[data-cart-note]')) selector = '[data-cart-note]';
    else if (active.matches('[data-cart-qty]')) selector = '[data-cart-qty="' + active.getAttribute('data-cart-qty') + '"]';
    else if (active.matches('[data-cart-drawer-close]')) selector = '.cart-drawer__close';
    if (!selector) return null;
    return { selector: selector, key: key, selectionEnd: typeof active.selectionEnd === 'number' ? active.selectionEnd : null };
  }

  function focusRestore(snapshot) {
    var panel = getPanel();
    if (!panel) return;
    if (!snapshot) {
      panel.focus();
      return;
    }
    var scope = snapshot.key ? panel.querySelector('.cart-drawer__item[data-line-key="' + snapshot.key + '"]') : panel;
    var el = scope ? scope.querySelector(snapshot.selector) : null;
    if (!el) el = panel.querySelector(snapshot.selector);
    if (el && typeof el.focus === 'function') {
      el.focus();
      if (snapshot.selectionEnd !== null && typeof el.setSelectionRange === 'function') {
        try { el.setSelectionRange(snapshot.selectionEnd, snapshot.selectionEnd); } catch (e) {}
      }
    } else {
      panel.focus();
    }
  }

  function canReturnFocus(target) {
    if (!target || target === document.body || !document.contains(target) || target.disabled ||
      !target.getClientRects().length || target.closest('[inert], [hidden], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(target);
    return style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.display !== 'none';
  }

  function prepareOpening(retainFocus) {
    var detail = { surface: 'cart', owner: getDrawer(), returnFocus: null };
    document.dispatchEvent(new CustomEvent('fh:surface:opening', { detail: detail }));
    // The outgoing surface can supply its stable trigger before hiding itself.
    // Capture after synchronous transfer, before our own background isolation.
    if (retainFocus) return;
    var target = detail.returnFocus || document.activeElement;
    if (!canReturnFocus(lastFocus)) lastFocus = canReturnFocus(target) ? target : document.querySelector('.header-cart > a');
  }

  function onSurfaceOpening(event) {
    var detail = event.detail;
    if (!detail || (detail.surface !== 'discovery' && detail.surface !== 'filters' && detail.surface !== 'material' && detail.surface !== 'account')) return;
    var drawer = getDrawer();
    var hadFocus = drawer && drawer.contains(document.activeElement), target = lastFocus;
    // Invalidate pending auto-open even while already closed. Never cancel a POST.
    close({ restoreFocus: false });
    // Validate only after releasing the inert state owned by this drawer.
    if (hadFocus && !detail.returnFocus) {
      detail.returnFocus = canReturnFocus(target) ? target : document.querySelector('.header-cart > a');
    }
  }

  function open() {
    var openingRevision = ++visibilityRevision;
    var wasOpen = isOpen();
    prepareOpening(wasOpen);
    if (openingRevision !== visibilityRevision) return;
    applyOpenState();
    scheduleUpsells();
    if (!wasOpen) {
      document.dispatchEvent(new CustomEvent('caffeine:cart:open', { bubbles: true, detail: { source: 'drawer' } }));
    }
  }

  function close(options) {
    visibilityRevision++;
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    restoreBackground();
    var returnFocus = canReturnFocus(lastFocus) ? lastFocus : document.querySelector('.header-cart > a');
    if ((!options || options.restoreFocus !== false) && canReturnFocus(returnFocus)) returnFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function parseCart(data) {
    return data && typeof data.item_count === 'number' && Array.isArray(data.items) ? data : null;
  }

  function fetchCart() {
    return controller.readJSON(route('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
  }

  // Capture what the drawer showed before a re-render so the new render can
  // animate from it (progress meter, new lines, count).
  function motionSnapshot() {
    var drawer = getDrawer();
    if (!drawer) return null;
    var fill = drawer.querySelector('.cart-drawer__progress-fill');
    var progress = drawer.querySelector('.cart-drawer__progress');
    var keys = Array.prototype.map.call(drawer.querySelectorAll('.cart-drawer__item'), function (li) {
      return li.getAttribute('data-line-key');
    });
    var qtys = {};
    Array.prototype.forEach.call(drawer.querySelectorAll('.cart-drawer__item'), function (li) {
      var input = li.querySelector('.cart-drawer__qty-input');
      qtys[li.getAttribute('data-line-key')] = input ? input.value : null;
    });
    return {
      fill: fill ? parseFloat(fill.style.width) || 0 : null,
      hadProgress: !!progress,
      progressHeight: progress ? progress.getBoundingClientRect().height : 0,
      keys: keys,
      qtys: qtys,
      count: drawer.querySelector('.cart-drawer__count') ? drawer.querySelector('.cart-drawer__count').textContent : '',
      completeSteps: drawer.querySelectorAll('.cart-drawer__progress-step.is-complete').length,
    };
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateAfterSwap(before, opts) {
    var drawer = getDrawer();
    if (!drawer) return;
    var reduce = prefersReducedMotion();
    var fill = drawer.querySelector('.cart-drawer__progress-fill');
    var progress = drawer.querySelector('.cart-drawer__progress');

    // Progress meter: FLIP from the previous width to the new one, then let the
    // step dots pop when they complete.
    if (fill && before && before.fill !== null && !reduce) {
      var target = fill.style.width;
      fill.style.transition = 'none';
      fill.style.width = before.fill + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(function () {
        fill.style.width = target;
      });
    }
    if (progress && before && !reduce) {
      var completeNow = progress.querySelectorAll('.cart-drawer__progress-step.is-complete').length;
      if (completeNow > (before.completeSteps || 0)) {
        var steps = progress.querySelectorAll('.cart-drawer__progress-step.is-complete');
        var last = steps[steps.length - 1];
        if (last) last.classList.add('is-celebrating');
      }
      // Slide the whole card in/out when it appears or disappears.
      if (!before.hadProgress) progress.classList.add('is-entering');
      var msg = progress.querySelector('.cart-drawer__progress-message');
      if (msg) msg.classList.add('is-updating');
    }

    // New lines: mark them so CSS can play the "added" entrance + check draw.
    if (before && !reduce) {
      var known = {};
      (before.keys || []).forEach(function (k) { known[k] = true; });
      Array.prototype.forEach.call(drawer.querySelectorAll('.cart-drawer__item'), function (li) {
        var key = li.getAttribute('data-line-key');
        if (!known[key]) {
          li.classList.add('is-new');
        } else {
          var input = li.querySelector('.cart-drawer__qty-input');
          if (input && before.qtys && before.qtys[key] != null && before.qtys[key] !== input.value) {
            input.classList.add('is-bumping');
          }
        }
      });
    }

    // Header count pulse when it changes.
    var count = drawer.querySelector('.cart-drawer__count');
    if (count && before && before.count !== count.textContent && !reduce) {
      count.classList.add('is-pulsing');
    }
  }

  function swapDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('#CartDrawer') || doc.querySelector('[data-cart-drawer]');
    if (!next) throw new Error('Invalid cart drawer section');
    var current = getDrawer();
    if (current) {
      // Carry the open state across so the panel does not re-slide in on every
      // update, and keep the body scrolled where the shopper left it.
      if (current.classList.contains('is-active')) {
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');
      }
      var currentBody = current.querySelector('.cart-drawer__body');
      var nextBody = next.querySelector('.cart-drawer__body');
      var scrollTop = currentBody ? currentBody.scrollTop : 0;
      current.replaceWith(next);
      if (nextBody && scrollTop) nextBody.scrollTop = scrollTop;
    } else {
      document.body.appendChild(next);
    }
    ensureOnBody();
  }

  function swapHeader(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextCarts = doc.querySelectorAll('.header-cart');
    var currentCarts = document.querySelectorAll('.header-cart');
    currentCarts.forEach(function (el, i) {
      if (nextCarts[i]) el.replaceWith(nextCarts[i].cloneNode(true));
    });
  }

  function renderCart(opts) {
    opts = opts || {};
    var shouldOpen = !!opts.open;
    var source = opts.source;
    var sections = opts.sections || null;
    var knownCart = parseCart(opts.cart);
    var wasOpen = isOpen();
    var visibilityBefore = typeof opts.visibilityRevision === 'number' ? opts.visibilityRevision : visibilityRevision;
    var focusBefore = opts.restoreFocus || (wasOpen ? focusSnapshot() : null);
    var motionBefore = motionSnapshot();

    var sectionPromise = sections
      ? Promise.resolve(sections)
      : controller.readJSON(route('cart') + '?sections=' + encodeURIComponent(sectionIds()), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });

    var cartPromise = knownCart ? Promise.resolve(knownCart) : fetchCart();

    return Promise.all([sectionPromise, cartPromise])
      .then(function (results) {
        var htmlMap = results[0] || {};
        if (!htmlMap[DRAWER_SECTION_ID]) throw new Error('Cart drawer section unavailable');
        var cart = results[1];
        var headerId = headerSectionId();
        var openBeforeSwap = isOpen(), renderVisibility = visibilityRevision;
        var openedByRender = shouldOpen && visibilityBefore === visibilityRevision && !isOpen();
        swapDrawer(htmlMap[DRAWER_SECTION_ID]);
        var note = getDrawer().querySelector('[data-cart-note]');
        if (note && pendingNote !== null) note.value = pendingNote;
        quantityEdits.restore(function (key, value, error) {
          var item = findItem(key);
          var input = item && item.querySelector('.cart-drawer__qty-input');
          if (input) input.value = value;
          if (error) showItemError(item, error.description || error.message);
        });
        setCheckoutBusy(checkoutPending);
        if (headerId) swapHeader(htmlMap[headerId]);
        animateAfterSwap(motionBefore, opts);
        scheduleUpsells();
        if (openedByRender) {
          prepareOpening();
          openedByRender = visibilityBefore === visibilityRevision && !isOpen();
        }
        if ((openBeforeSwap && renderVisibility === visibilityRevision) || openedByRender) {
          applyOpenState({ focus: false });
          focusRestore(focusBefore);
        }
        document.dispatchEvent(
          new CustomEvent('caffeine:cart:changed', {
            bubbles: true,
            detail: { cart: cart, source: source || 'drawer' },
          })
        );
        if (openedByRender) {
          document.dispatchEvent(
            new CustomEvent('caffeine:cart:open', { bubbles: true, detail: { source: 'drawer' } })
          );
        }
        return cart;
      });
  }

  function addSectionsFields(body, isFormData) {
    var ids = sectionIds();
    var url = window.location.pathname;
    if (isFormData) {
      body.set('sections', ids);
      body.set('sections_url', url);
      return body;
    }
    body.sections = ids;
    body.sections_url = url;
    return body;
  }

  function refresh(opts) {
    var request = Object.assign({}, opts, { visibilityRevision: visibilityRevision });
    return controller.enqueue(function () { return renderCart(request); });
  }

  function addConfirmed(formDataOrItems, opts) {
    opts = opts || {};
    var isForm = typeof FormData !== 'undefined' && formDataOrItems instanceof FormData;
    var body = isForm ? formDataOrItems : Object.assign({},
      formDataOrItems && formDataOrItems.items ? formDataOrItems : { items: formDataOrItems });
    return controller.mutate('add', addSectionsFields(body, isForm), {
      open: opts.open !== false, source: opts.source || 'product_form', visibilityRevision: visibilityRevision
    });
  }

  function add(payload, opts) {
    return addConfirmed(payload, opts).then(function (result) { return result.data; });
  }

  function change(params) {
    params = params || {};
    if (!Number.isInteger(params.quantity) || params.quantity < 0) {
      return Promise.reject(new Error('Choose a valid quantity'));
    }
    var body = { quantity: params.quantity };
    if (params.line != null) body.line = params.line;
    if (params.id != null) body.id = params.id;
    if (params.properties) body.properties = params.properties;
    return controller.mutate('change', addSectionsFields(body, false), {
      source: 'cart_drawer', restoreFocus: params.restoreFocus, visibilityRevision: visibilityRevision
    }).then(function (result) { return result.data; });
  }

  function updateNote(note) {
    return controller.mutate('update', addSectionsFields({ note: note }, false), {
      source: 'cart_note', open: isOpen(), visibilityRevision: visibilityRevision
    }).then(function (result) { return result.data; });
  }

  function savePendingNote() {
    clearTimeout(noteTimer);
    if (pendingNote === null) return controller.idle();
    var revision = noteRevision;
    var value = pendingNote;
    return updateNote(value).then(function () {
      if (revision === noteRevision) pendingNote = null;
    });
  }

  function setCheckoutBusy(busy) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('.cart-drawer__body, .cart-drawer__note, form').forEach(function (element) {
      element.inert = busy;
    });
    var button = drawer.querySelector('[name="checkout"]');
    if (button) button.disabled = busy;
  }

  function onCheckoutSubmit(event) {
    var form = event.target;
    if (!getDrawer() || !getDrawer().contains(form) || !form.querySelector('[name="checkout"]')) return;
    event.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    setCheckoutBusy(true);
    Promise.all(Array.from(pendingOffers)).then(function () { return quantityEdits.flush(); }).then(savePendingNote).then(function () { return controller.idle(); }).then(function () {
      if (cartReviewRequired) throw new Error('Cart needs review');
      var currentForm = getDrawer().querySelector('form');
      var checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout';
      currentForm.appendChild(checkout);
      HTMLFormElement.prototype.submit.call(currentForm);
    }).catch(function () {
      if (cartReviewRequired) {
        return refresh({open:true}).then(function () {
          cartReviewRequired = false;
          showCartNotice('We refreshed your cart after an unconfirmed update. Review the items and totals, then check out again.');
        }, function () { showCartNotice('We could not verify your cart. Open View cart to review it before checkout.'); })
          .finally(function () { setCheckoutBusy(false); });
      }
      showCartNotice('Please review your unsaved quantity or note before checkout. Edit it again to save.');
      setCheckoutBusy(false);
    }).finally(function () { checkoutPending = false; });
  }

  function setItemLoading(item, loading) {
    if (!item) return;
    item.classList.toggle('is-loading', !!loading);
    var qty = item.querySelector('.cart-drawer__qty');
    if (qty) qty.classList.toggle('is-loading', !!loading);
    item.querySelectorAll('button, input, a').forEach(function (el) {
      if (loading) {
        if (!el.hasAttribute('data-cart-was-disabled')) el.setAttribute('data-cart-was-disabled', el.hasAttribute('disabled') ? 'true' : 'false');
        el.setAttribute('disabled', 'disabled');
      } else if (el.hasAttribute('data-cart-was-disabled')) {
        if (el.getAttribute('data-cart-was-disabled') === 'false') el.removeAttribute('disabled');
        el.removeAttribute('data-cart-was-disabled');
      }
    });
  }

  function showItemError(item, message) {
    if (!item) return;
    var error = item.querySelector('.cart-drawer__item-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'cart-drawer__item-error';
      item.appendChild(error);
    }
    error.hidden = false;
    error.textContent = message || '';
  }

  function findItem(key) {
    return Array.prototype.find.call(getDrawer().querySelectorAll('.cart-drawer__item'), function (item) {
      return item.getAttribute('data-line-key') === key;
    });
  }

  function saveQuantity(key, value) {
    var item = findItem(key);
    var quantity = Number(value);
    if (!item || String(value).trim() === '' || !Number.isInteger(quantity) || quantity < 0) {
      var error = new Error(item ? 'Enter a whole quantity of zero or more.' : 'Your cart changed. Review the current items before checkout.');
      showItemError(item, error.message);
      return Promise.reject(error);
    }
    var focusBefore = focusSnapshot();
    setItemLoading(item, true);
    // A mini is sold with its Big Head: it rides that proof and only earns its
    // discount while the Big Head is in the cart. Removing the Big Head takes
    // its minis with it, in ONE write, so no orphan is left at full price.
    var minis = quantity === 0 ? linkedMinis(item) : [];
    var write;
    if (minis.length) {
      var updates = {};
      updates[key] = 0;
      minis.forEach(function (mini) { setItemLoading(mini, true); updates[mini.dataset.lineKey] = 0; });
      write = controller.mutate('update', addSectionsFields({ updates: updates }, false), {
        source: 'cart_drawer', restoreFocus: focusBefore, visibilityRevision: visibilityRevision
      }).then(function (result) { return result.data; });
    } else {
      write = change({ id: key, quantity: quantity, restoreFocus: focusBefore });
    }
    return write.catch(function (err) {
      minis.forEach(function (mini) { setItemLoading(findItem(mini.dataset.lineKey), false); });
      setItemLoading(findItem(key), false);
      showItemError(findItem(key), err.description || err.message);
      throw err;
    });
  }

  function changeFromControl(el) {
    var key = el.getAttribute('data-line-key');
    var value = el.hasAttribute('data-cart-remove') ? '0' : el.getAttribute('data-cart-qty');
    if (el.hasAttribute('data-cart-delta')) {
      var input = el.closest('.cart-drawer__item').querySelector('.cart-drawer__qty-input');
      var currentValue = input.value;
      value = currentValue.trim() !== '' && Number.isInteger(Number(currentValue))
        ? String(Number(currentValue) + Number(el.getAttribute('data-cart-delta'))) : currentValue;
    }
    quantityEdits.set(key, value);
    quantityEdits.flush().catch(function (error) { showCartNotice(error.description || error.message); });
  }

  function designSignature(variantId, properties) {
    function stable(value) {
      if (Array.isArray(value)) return value.map(stable);
      if (value && typeof value === 'object') return Object.keys(value).sort().reduce(function (out, key) { out[key] = stable(value[key]); return out; }, {});
      return value;
    }
    // Liquid serializes a property hash as key/value pairs; Ajax returns an object.
    if (Array.isArray(properties)) properties = properties.reduce(function (out, pair) { out[pair[0]] = pair[1]; return out; }, {});
    properties = Object.assign({}, properties || {});
    delete properties._fh_copy_decision; // Measurement must not change design identity.
    return JSON.stringify([String(variantId), stable(properties)]);
  }

  function matchingDesign(signature) {
    return Array.prototype.find.call(getDrawer().querySelectorAll('.cart-drawer__item'), function (item) {
      try { return designSignature(item.dataset.variantId, JSON.parse(item.dataset.properties)) === signature; }
      catch (_) { return false; }
    });
  }

  function addSecondCopy(button) {
    if (button.disabled || checkoutPending) return;
    var original = button.closest('.cart-drawer__item'), signature;
    try { signature = designSignature(original.dataset.variantId, JSON.parse(original.dataset.properties)); }
    catch (_) { showCartNotice('Your cart changed. Review this design before adding another copy.'); return; }
    var copyAttribution = window.FatheadSecondCopyAttribution && window.FatheadSecondCopyAttribution(original);
    var visibilityBefore = visibilityRevision;
    function notice(message) { showCartNotice(message, {open:visibilityBefore === visibilityRevision}); }
    setItemLoading(original, true);
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding your second copy…';
    var task = quantityEdits.flush().then(function () { return controller.idle(); }).then(function () {
      var item = matchingDesign(signature);
      if (!item || Number(item.querySelector('.cart-drawer__qty-input').value) !== 1) throw new Error('This design has already changed. Review its current quantity.');
      var payload = {id:item.dataset.lineKey,quantity:2};
      if (copyAttribution) {
        var properties = JSON.parse(item.dataset.properties);
        if (Array.isArray(properties)) properties = properties.reduce(function(out,pair){out[pair[0]]=pair[1];return out;},{});
        payload.properties = Object.assign({}, properties, {_fh_copy_decision:copyAttribution.decisionId});
      }
      return controller.mutate('change', addSectionsFields(payload, false), {source:'custom_second_copy',open:false});
    }).then(function (result) {
      if (copyAttribution) copyAttribution.committed(result.data);
      if (result.renderError) return; // Confirmed mutation: never retry because the section failed.
      var item = matchingDesign(signature);
      // Match the refreshed Liquid design first, then its exact new Ajax line key.
      // Shopify's Liquid and Ajax serializers can encode nested custom properties
      // differently; discounting can also change the key captured before the write.
      var line = item && result.data.items.find(function (line) {
        return line.key === item.dataset.lineKey && String(line.variant_id) === item.dataset.variantId;
      });
      if (!item || !line || line.quantity !== 2) { notice('Your cart was updated. Please review this design’s quantity.'); return; }
      var saving = line.original_line_price - line.final_line_price;
      var discount = (line.line_level_discount_allocations || []).some(function (allocation) {
        var app = allocation.discount_application || {};
        return app.value_type === 'percentage' && Number(app.value) === 5 || /2 or more of your design/i.test(app.title || '');
      });
      if (!discount || saving <= 0) { notice('Second copy added. The 5% saving could not be verified; please review your totals.'); return; }
      var success = document.createElement('p');
      success.className = 'fh-copy-success'; success.tabIndex = -1; success.setAttribute('role','status');
      success.textContent = 'Second copy added · 5% off both';
      item.appendChild(success);
      if (!prefersReducedMotion()) { item.classList.add('is-copy-added'); item.querySelector('.cart-drawer__qty-input').classList.add('is-bumping'); }
      if (visibilityBefore === visibilityRevision && isOpen()) success.focus({preventScroll:true});
    }).catch(function (error) {
      if (copyAttribution) copyAttribution.failed();
      var item = matchingDesign(signature);
      setItemLoading(item, false); showItemError(item, error.description || error.message);
      var retry = item && item.querySelector('[data-custom-copy]');
      if (retry) { retry.removeAttribute('aria-busy'); retry.textContent='Add a second · save 5% on both'; }
      notice(error.description || error.message);
      throw error;
    });
    pendingOffers.add(task);
    task.then(function () { pendingOffers.delete(task); }, function () { pendingOffers.delete(task); });
  }

  function lineProperties(item) {
    var properties = JSON.parse(item.dataset.properties);
    // Liquid serializes a property hash as key/value pairs; Ajax returns an object.
    if (Array.isArray(properties)) properties = properties.reduce(function (out, pair) { out[pair[0]] = pair[1]; return out; }, {});
    return Object.assign({}, properties || {});
  }

  function isMiniLine(item) { return !!item && item.hasAttribute('data-mini-line'); }

  // The mini lines sold with this Big Head: same link key, flagged as minis.
  function linkedMinis(item) {
    var key = item && !isMiniLine(item) && item.dataset.linkKey;
    if (!key || !getDrawer()) return [];
    return Array.prototype.filter.call(getDrawer().querySelectorAll('.cart-drawer__item[data-mini-line]'), function (mini) {
      return mini.dataset.linkKey === key;
    });
  }

  // Which companion a card offers: Minis (the default) or Ornaments.
  function offerKind(button) { return button && button.getAttribute('data-offer-kind') === 'ornament' ? 'ornament' : 'mini'; }
  function offerNoun(button) { return offerKind(button) === 'ornament' ? 'ornaments' : 'minis'; }

  // This Big Head's companions of the card's kind: an ornaments card counts
  // only its product's variants, a minis card only the minis variant.
  function linkedOfKind(item, button) {
    var listed = (button.getAttribute('data-companion-variants') || '').split(',').map(function (id) { return id.trim(); }).filter(Boolean);
    var variants = listed.length ? listed : [String(button.getAttribute('data-mini-variant') || '')];
    return linkedMinis(item).filter(function (line) { return variants.indexOf(String(line.dataset.variantId)) !== -1; });
  }

  // The ornament size picker: the button adds the chosen variant and the card
  // shows that variant's prices.
  function selectOrnamentSize(select) {
    var card = select.closest('[data-mini-offer-card]'), option = select.options[select.selectedIndex];
    var button = card && card.querySelector('[data-mini-offer]');
    if (!button || !option) return;
    button.setAttribute('data-mini-variant', option.value);
    button.setAttribute('data-mini-size', option.getAttribute('data-size') || '');
    var was = card.querySelector('[data-ornament-was]'), now = card.querySelector('[data-ornament-now]');
    if (was && option.getAttribute('data-was')) was.textContent = option.getAttribute('data-was');
    if (now && option.getAttribute('data-now')) now.textContent = option.getAttribute('data-now');
  }

  // The design portal's kit contract (cart-properties-v1 buildUpsellLineProperties):
  // a companion shares its parent's proof-shaped properties and `_LinkedProofKey`,
  // but must NOT inherit the parent's size, product type or material, and carries
  // `_MiniUpsell` (the portal's companion marker, ornaments included) so the
  // portal and the discount Function recognize it.
  function miniProperties(parent, button) {
    var properties = lineProperties(parent), ornament = offerKind(button) === 'ornament';
    ['_Size', '_CustomProductType', '_Material', '_fh_copy_decision', '_fh_qty_decision', '_cc_rec_decision', '_cc_rec_placement']
      .forEach(function (key) { delete properties[key]; });
    properties._CustomProductType = ornament ? 'Big Head Ornament' : 'Big Head Minis';
    var size = (button.getAttribute('data-mini-size') || '').trim(), inParens = size.match(/\(([^)]*)\)/);
    // Minis: '12"W x 18"H' as is. Ornaments: "Medium 12x17 (6 on a sheet)" is
    // the sheet, so keep the part before the count.
    if (size) properties._Size = ornament ? size.replace(/\s*\([^)]*\)\s*/g, ' ').trim() : inParens ? inParens[1].trim() : size;
    var material = (button.getAttribute('data-mini-material') || '').trim();
    if (material) properties._Material = material;
    properties._MiniUpsell = 'true';
    properties._MiniSource = 'cart'; // Where the minis were offered, for reporting.
    return properties;
  }

  // Minis offer reporting. "Shown" and "added" go to the design portal's public
  // customizer event sink (the same one the in-customizer minis card uses), which
  // the Hub reads. Anonymous: a random per-tab session id and product ids only.
  // Live theme only, never when analytics consent is declined, and never allowed
  // to affect the cart: every failure is swallowed.
  var MINI_TRACK_URL = 'https://fathead-customs.com/api/customizer/track';
  function miniTrackingAllowed() {
    var shopify = window.Shopify || {}, privacy = shopify.customerPrivacy;
    if (!shopify.theme || shopify.theme.role !== 'main' || shopify.designMode) return false;
    return !(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === false);
  }
  function miniSession() {
    try {
      var id = sessionStorage.getItem('fh:mini:sid');
      if (!id) { id = crypto.randomUUID(); sessionStorage.setItem('fh:mini:sid', id); }
      return id;
    } catch (_) { return null; }
  }
  function trackMiniOffer(eventType, parent, button, extra) {
    try {
      var sessionId = miniTrackingAllowed() && miniSession();
      if (!sessionId || !parent || !button) return;
      fetch(MINI_TRACK_URL, { method: 'POST', keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventType: eventType, sessionId: sessionId, shopifyProductId: String(parent.dataset.productId || ''),
          shopifyVariantId: String(parent.dataset.variantId || ''), productType: 'big_head',
          metadata: Object.assign({ kind: offerKind(button), placement: 'cart', upsellVariantId: String(button.getAttribute('data-mini-variant') || '') }, extra || {}) }) })
        .catch(function () {});
    } catch (_) {}
  }
  // One "shown" per design per tab, and only once the drawer is actually open.
  function reportMiniOffersShown() {
    try {
      if (!isOpen() || !getDrawer() || !miniTrackingAllowed()) return;
      var seen = JSON.parse(sessionStorage.getItem('fh:mini:shown') || '[]');
      Array.prototype.forEach.call(getDrawer().querySelectorAll('[data-mini-offer]'), function (button) {
        // Minis keep the bare key (as before); ornaments are their own offer.
        var parent = button.closest('.cart-drawer__item'), key = parent && parent.dataset.linkKey;
        var seenKey = key && (offerKind(button) === 'ornament' ? 'ornament:' + key : key);
        if (!seenKey || seen.indexOf(seenKey) !== -1) return;
        seen.push(seenKey);
        trackMiniOffer('upsell_shown', parent, button);
      });
      sessionStorage.setItem('fh:mini:shown', JSON.stringify(seen.slice(-50)));
    } catch (_) {}
  }

  // The first uploaded-artwork URL on a line. Liquid and Ajax serialize
  // `_imageLayers` differently, so compare the artwork, not the raw value.
  function miniDesignUrl(properties) {
    var value = properties && properties._imageLayers;
    var text = typeof value === 'string' ? value : JSON.stringify(value || '');
    var match = text.match(/https?:\/\/[^\s"'<>\\]+/i);
    return match ? match[0] : '';
  }

  function addMiniOffer(button) {
    if (button.disabled || checkoutPending) return;
    var parent = button.closest('.cart-drawer__item'), signature, linkKey;
    var variantId = button.getAttribute('data-mini-variant'), percent = Number(button.getAttribute('data-mini-percent')) || 15;
    var label = button.getAttribute('data-mini-label') || button.textContent;
    var noun = offerNoun(button), Noun = noun.charAt(0).toUpperCase() + noun.slice(1);
    try {
      signature = designSignature(parent.dataset.variantId, JSON.parse(parent.dataset.properties));
      linkKey = String(lineProperties(parent)._LinkedProofKey || '').trim();
    } catch (_) { linkKey = ''; }
    // The companion is this design. Without the artwork to copy there is nothing to sell.
    var design = linkKey ? miniDesignUrl(lineProperties(parent)) : '';
    if (!linkKey || !variantId || !design) { showCartNotice('Your cart changed. Review this design before adding ' + noun + '.'); return; }
    var attribution = window.FatheadMiniOfferAttribution && window.FatheadMiniOfferAttribution(parent);
    var visibilityBefore = visibilityRevision;
    function notice(message) { showCartNotice(message, {open:visibilityBefore === visibilityRevision}); }
    setItemLoading(parent, true);
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding your ' + noun + '…';
    var task = quantityEdits.flush().then(function () { return controller.idle(); }).then(function () {
      var item = matchingDesign(signature);
      if (!item || isMiniLine(item)) throw new Error('This design has already changed. Review it before adding ' + noun + '.');
      if (linkedOfKind(item, button).length) throw new Error(Noun + ' of this design are already in your cart.');
      var properties = miniProperties(item, button);
      if (attribution) properties._fh_mini_decision = attribution.decisionId;
      return controller.mutate('add', addSectionsFields({items:[{id:Number(variantId),quantity:1,properties:properties}]}, false), {source:'cart_mini_offer',open:false});
    }).then(function (result) {
      if (attribution) attribution.committed(result.data);
      if (result.renderError) return; // Confirmed mutation: never retry because the section failed.
      // Confirm what Shopify now holds: a minis line with the marker, this
      // design's link key AND this design's artwork. The design portal builds
      // the proof and print file from those, so a minis line missing any of
      // them is taken back out rather than left in the cart.
      var minis = (result.data.items || []).filter(function (line) { return String(line.variant_id) === String(variantId); });
      var keyOf = function (line) { return String((line.properties || {})._LinkedProofKey || '').trim(); };
      var line = minis.find(function (line) {
        var mini = String((line.properties || {})._MiniUpsell || '').trim().toLowerCase();
        return mini && mini !== 'false' && keyOf(line) === linkKey && miniDesignUrl(line.properties) === design;
      });
      if (!line) {
        var updates = {}, broken = minis.filter(function (line) { return (keyOf(line) === linkKey || !keyOf(line)) && miniDesignUrl(line.properties) !== design; });
        broken.forEach(function (line) { updates[line.key] = 0; });
        var failed = function () { notice('We couldn’t add your ' + noun + ' with your design. Please try again.'); };
        if (!broken.length) { failed(); return; }
        return controller.mutate('update', addSectionsFields({ updates: updates }, false), { source: 'cart_mini_offer', open: false }).then(failed, failed);
      }
      var saving = line.original_line_price - line.final_line_price;
      var discount = (line.line_level_discount_allocations || []).some(function (allocation) {
        var app = allocation.discount_application || {};
        return app.value_type === 'percentage' && Number(app.value) === percent || /matching (mini|ornaments)/i.test(app.title || '');
      });
      trackMiniOffer('upsell_accepted', parent, button, { discountVerified: !!(discount && saving > 0) });
      if (!discount || !(saving > 0)) { notice(Noun + ' added. The ' + percent + '% saving could not be verified; please review your totals.'); return; }
      var item = matchingDesign(signature), mini = item && linkedOfKind(item, button)[0];
      var target = mini || item;
      if (!target) return;
      var success = document.createElement('p');
      success.className = 'fh-copy-success'; success.tabIndex = -1; success.setAttribute('role','status');
      success.textContent = Noun + ' added · ' + percent + '% off';
      target.appendChild(success);
      if (!prefersReducedMotion()) target.classList.add('is-copy-added');
      if (visibilityBefore === visibilityRevision && isOpen()) success.focus({preventScroll:true});
    }).catch(function (error) {
      if (attribution) attribution.failed();
      var item = matchingDesign(signature);
      setItemLoading(item, false); showItemError(item, error.description || error.message);
      var retry = item && item.querySelector('[data-mini-offer]');
      if (retry) { retry.removeAttribute('aria-busy'); retry.textContent = label; }
      notice(error.description || error.message);
      throw error;
    });
    pendingOffers.add(task);
    task.then(function () { pendingOffers.delete(task); }, function () { pendingOffers.delete(task); });
  }

  function onDocumentClick(event) {
    if (event.target.closest('[disabled]')) { event.preventDefault(); return; }
    var closeEl = event.target.closest('[data-cart-drawer-close]');
    if (closeEl && getDrawer() && (getDrawer().contains(closeEl) || closeEl === getDrawer().querySelector('[data-cart-drawer-close]'))) {
      event.preventDefault();
      close();
      return;
    }

    var headerLink = event.target.closest('.header-cart > a');
    if (headerLink) {
      var onAdd = theme.settings && theme.settings.onAddToCart;
      if (document.body.classList.contains('template-cart') || onAdd !== 'ajax') return;
      event.preventDefault();
      lastFocus = headerLink;
      open();
      return;
    }

    var quickbuy = event.target.closest('[data-cart-quickbuy]');
    if (quickbuy && getDrawer() && getDrawer().contains(quickbuy)) { event.preventDefault(); openQuickBuy(quickbuy); return; }

    var upsell = event.target.closest('[data-upsell-variant]');
    if (upsell && getDrawer() && getDrawer().contains(upsell)) {
      event.preventDefault();
      onUpsellAdd(upsell);
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove && getDrawer() && getDrawer().contains(remove)) {
      event.preventDefault();
      changeFromControl(remove);
      return;
    }

    var copy = event.target.closest('[data-custom-copy]');
    if (copy && getDrawer() && getDrawer().contains(copy)) { event.preventDefault(); addSecondCopy(copy); return; }

    var miniOffer = event.target.closest('[data-mini-offer]');
    if (miniOffer && getDrawer() && getDrawer().contains(miniOffer)) { event.preventDefault(); addMiniOffer(miniOffer); return; }

    var qtyBtn = event.target.closest('[data-cart-qty][data-line-key]');
    if (qtyBtn && qtyBtn.tagName !== 'INPUT' && getDrawer() && getDrawer().contains(qtyBtn)) {
      event.preventDefault();
      changeFromControl(qtyBtn);
    }
  }

  function onDocumentInput(event) {
    var note = event.target.closest('[data-cart-note]');
    if (note) { onDocumentChange(event); return; }
    var input = event.target.closest('.cart-drawer__qty-input');
    if (!input) return;
    if (!getDrawer() || !getDrawer().contains(input)) return;
    quantityEdits.set(input.getAttribute('data-line-key'), input.value);
  }

  function onDocumentChange(event) {
    var size = event.target.closest('[data-ornament-size]');
    if (size) { selectOrnamentSize(size); return; }
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    pendingNote = note.value;
    noteRevision++;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      savePendingNote().catch(function () { showCartNotice('Your cart note has not been saved.'); });
    }, 400);
  }

  function onKeydown(event) {
    if (!isOpen() || document.querySelector('[data-cart-quickbuy-dialog][open]')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var panel = getPanel();
    var items = focusable(panel);
    if (!items.length) {
      event.preventDefault();
      if (panel) panel.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  // Curated historical recommendations render in Liquid from versioned product
  // references. Keep this lifecycle hook for existing drawer sequencing.
  function scheduleUpsells() {}

  function splitTitle(title) {
    var words = String(title || '').split(' ');
    var first = [], third = [], found = false;
    words.forEach(function (w) {
      if (found) third.push(w);
      else if (/Official/.test(w)) { found = true; third.push(w); }
      else first.push(w);
    });
    var firstPart = first.join(' ');
    var idx = firstPart.indexOf(' - ');
    var line1 = idx > -1 ? firstPart.slice(0, idx) : firstPart;
    var line2 = idx > -1 ? firstPart.slice(idx + 3) : '';
    return { line1: line1.replace(/^-|-\s*$/g, '').trim(), line2: line2.replace(/^-|-\s*$/g, '').trim(), line3: third.join(' ').replace(/-/g, '').trim() };
  }

  // Fetch only the opened product. No variant payloads or modal instances per card.
  function openQuickBuy(trigger) {
    if (document.querySelector('[data-cart-quickbuy-dialog][open]')) return;
    if (cartReviewRequired) { showCartNotice('Please review your cart before adding another item.'); return; }
    var url;
    try { url = new URL(trigger.getAttribute('data-cart-quickbuy'), location.origin); } catch (_) { return; }
    if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
    var card = trigger.closest('[data-recommendation-product]'), quickAttribution = null;
    try { if (window.FatheadRecommendationAttribution) quickAttribution = window.FatheadRecommendationAttribution(card.dataset.recommendationProduct); } catch (_) {}
    var dialog = document.createElement('dialog');
    dialog.className = 'fh-quickbuy'; dialog.setAttribute('data-cart-quickbuy-dialog', '');
    dialog.setAttribute('aria-labelledby', 'QuickBuyTitle');
    dialog.innerHTML = '<button type="button" class="fh-quickbuy__close" aria-label="Close quickbuy">×</button><div class="fh-quickbuy__content"><div class="fh-quickbuy__intro"><img class="fh-quickbuy__image" alt="" hidden><div><p class="fh-quickbuy__eyebrow">Make it yours</p><h2 id="QuickBuyTitle">Choose your size</h2><p class="fh-quickbuy__subtitle"></p></div></div><p class="fh-quickbuy__status" role="status">Loading sizes…</p><div class="fh-quickbuy__options"></div><button type="button" class="fh-quickbuy__retry" hidden>Try again</button><a class="fh-quickbuy__details">View product details</a></div><div class="fh-quickbuy__footer"><span class="fh-quickbuy__price">Choose a size</span><button type="button" class="fh-quickbuy__add" disabled>Add to cart</button></div>';
    var status = dialog.querySelector('[role="status"]'), options = dialog.querySelector('.fh-quickbuy__options');
    var submit = dialog.querySelector('.fh-quickbuy__add'), closeButton = dialog.querySelector('.fh-quickbuy__close');
    var retry = dialog.querySelector('.fh-quickbuy__retry'), selected = null, busy = false, request = null;
    dialog.querySelector('.fh-quickbuy__details').href = url.pathname;
    function finish() {
      if (busy) return;
      if (request) request.abort();
      if (dialog.open) dialog.close();
      dialog.remove();
      var target = trigger.isConnected ? trigger : getPanel();
      if (target && isOpen()) target.focus({ preventScroll: true });
    }
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD' }).format(cents / 100);
    }
    function load() {
      if (request) request.abort(); request = new AbortController();
      status.textContent = 'Loading sizes…'; status.classList.add('is-loading'); retry.hidden = true;
      selected = null; submit.disabled = true; options.replaceChildren();
      controller.readJSON(url.pathname + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: request.signal }).then(function (product) {
        if (!dialog.isConnected) return;
        if (!product || String(product.id) !== card.dataset.recommendationProduct || product.requires_selling_plan || (product.tags || []).some(function (tag) { return ['customizable', 'customizable-name', 'fh-line-personalized-wall-decals'].indexOf(tag) !== -1; }) || /custom|personaliz|retouch/i.test(product.title)) throw new Error('Please view this product to configure it.');
        var variants = (product.variants || []).filter(function (v) { return !/sample/i.test(v.title); });
        if (!variants.length) throw new Error('Sizes are not available right now.');
        var title = String(product.title).split(' - ');
        dialog.querySelector('h2').textContent = title[0];
        dialog.querySelector('.fh-quickbuy__subtitle').textContent = title[1] || '';
        var image = dialog.querySelector('img');
        function showImage(src) { if (src) { var imageUrl = new URL(src, location.origin); if (imageUrl.protocol === 'https:') { imageUrl.searchParams.set('width', '480'); image.src = imageUrl.href; image.hidden = false; } } }
        showImage(product.featured_image);
        var fieldset = document.createElement('fieldset'), legend = document.createElement('legend');
        legend.textContent = product.options && product.options.length === 1 ? 'Choose ' + (product.options[0].name || product.options[0]).toLowerCase() : 'Choose your options';
        fieldset.appendChild(legend);
        variants.forEach(function (variant) {
          var label = document.createElement('label'), radio = document.createElement('input'), text = document.createElement('span'), price = document.createElement('span');
          radio.type = 'radio'; radio.name = 'quickbuy-variant'; radio.value = String(variant.id); radio.disabled = !variant.available;
          text.textContent = variant.title; price.textContent = variant.available ? money(variant.price) : 'Sold out';
          price.className = 'fh-quickbuy__option-price'; label.className = 'fh-quickbuy__option';
          label.append(radio, text, price); fieldset.appendChild(label);
          radio.addEventListener('change', function () {
            selected = variant; submit.disabled = false; status.textContent = '';
            dialog.querySelector('.fh-quickbuy__price').textContent = money(variant.price);
            showImage(variant.featured_image && variant.featured_image.src || product.featured_image);
          });
        });
        options.appendChild(fieldset);
        status.textContent = variants.some(function (v) { return v.available; }) ? '' : 'This item is currently sold out.';
      }).catch(function (error) {
        if (!dialog.isConnected || error.name === 'AbortError') return;
        status.textContent = error.message || 'We could not load sizes. Please try again.'; retry.hidden = false;
      }).finally(function () { status.classList.remove('is-loading'); });
    }
    closeButton.addEventListener('click', finish);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); finish(); });
    dialog.addEventListener('click', function (event) {
      var box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) finish();
    });
    retry.addEventListener('click', load);
    submit.addEventListener('click', function () {
      if (busy || !selected || !selected.available) return;
      busy = true; submit.disabled = true; closeButton.disabled = true;
      options.querySelector('fieldset').disabled = true;
      submit.textContent = 'Adding…'; submit.setAttribute('aria-busy', 'true');
      var attribution = quickAttribution, item = { id: selected.id, quantity: 1 };
      if (attribution) item.properties = { _cc_rec_decision: attribution.decisionId };
      var pending = addConfirmed({ items: [item] }, { open: true, source: 'cart_quickbuy' }).then(function () {
        try { if (attribution) attribution.committed(); } catch (_) {}
        busy = false; finish();
      }, function (error) {
        try { if (attribution) attribution.failed(); } catch (_) {}
        busy = false; closeButton.disabled = false; submit.removeAttribute('aria-busy'); submit.textContent = 'Add to cart';
        if (error.outcome === 'unknown') { finish(); showCartNotice('We could not confirm that addition. Review your cart before trying again.'); return; }
        options.querySelector('fieldset').disabled = false; submit.disabled = false;
        status.textContent = error.description || error.message || 'Unable to add this size. Please choose another or try again.';
      });
      pendingOffers.add(pending); pending.finally(function () { pendingOffers.delete(pending); });
    });
    getDrawer().appendChild(dialog); dialog.showModal(); load();
  }

  function onUpsellAdd(button) {
    var variantId = button.getAttribute('data-upsell-variant');
    if (!variantId || button.disabled || button.classList.contains('is-loading')) return;
    var card = button.closest('[data-recommendation-product]'), attribution = null;
    try { if (window.FatheadRecommendationAttribution && card) attribution = window.FatheadRecommendationAttribution(card.dataset.recommendationProduct); } catch (_) {}
    var item = {id:Number(variantId),quantity:1};
    if (attribution) item.properties = {_cc_rec_decision:attribution.decisionId};
    button.classList.add('is-loading'); button.disabled = true; button.setAttribute('aria-busy','true');
    var label = button.textContent; button.textContent = 'Adding…';
    addConfirmed({ items: [item] }, { open:true,source:'cart_companion' }).then(function () {
      try { if(attribution)attribution.committed(); } catch (_) {}
    }, function (error) {
      try { if(attribution)attribution.failed(); } catch (_) {}
      button.classList.remove('is-loading'); button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label;
      showCartNotice(error.description || error.message || 'We could not add this item.');
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ajaxAddToCartForm($form) {
    $form.each(function () {
      var form = this;
      form.dataset.cartDrawerBound = 'true';
      $(form).off('submit', onAjaxFormSubmit).on('submit.fatheadCart', onAjaxFormSubmit);
    });
  }

  // Native cart/add forms injected by navigation or app sections do not use the theme's jQuery initializer.
  function onNativeProductSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || form.matches('.ajax-product-form') || !getDrawer()) return;
    var action; try { action = new URL(form.action, location.href); } catch (_) { return; }
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname) || String(form.method).toLowerCase() !== 'post') return;
    if (theme.settings && theme.settings.onAddToCart !== 'ajax') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.nativeCartPending === 'true') return;
    if (window.FatheadPersonalizedName && !window.FatheadPersonalizedName.validateForm(form)) return;
    var body = new FormData(form), submitter = event.submitter;
    if (submitter && submitter.name) body.append(submitter.name, submitter.value);
    form.dataset.nativeCartPending = 'true'; form.setAttribute('aria-busy','true');
    var controls = Array.prototype.map.call(form.querySelectorAll('[type=submit]'),function(button){var state={button:button,disabled:button.disabled,text:button.tagName==='INPUT'?button.value:button.textContent};button.disabled=true;if(button.tagName==='INPUT')button.value='Adding…';else button.textContent='Adding…';return state;});
    addConfirmed(body,{source:'native_product_form',open:true}).catch(function(error){showCartNotice(error.description||error.message);}).finally(function(){
      delete form.dataset.nativeCartPending; form.removeAttribute('aria-busy');
      controls.forEach(function(state){state.button.disabled=state.disabled;if(state.button.tagName==='INPUT')state.button.value=state.text;else state.button.textContent=state.text;});
    });
  }

  function onAjaxFormSubmit(event) {
    event.preventDefault();
    var form = this, $formEl = $(form);
    if (form.dataset.nativeCartPending === 'true') return;
    if (window.FatheadPersonalizedName && !window.FatheadPersonalizedName.validateForm(form)) return;
    var body = new FormData(form);
    var submitter = event.originalEvent && event.originalEvent.submitter;
    if (submitter && submitter.name) body.append(submitter.name, submitter.value);
    form.dataset.nativeCartPending = 'true'; form.setAttribute('aria-busy', 'true');
    var controls = [];
    $formEl.addClass('add-in-progress').find(':submit').each(function () {
      var $btn = $(this), method = $btn.is('button') ? 'html' : 'val';
      controls.push({ button: $btn, disabled: this.disabled, method: method, label: $btn[method]() });
      $btn.attr('disabled', 'disabled')[method](theme.strings.addingToCart);
    });
    function restore() {
      controls.forEach(function (state) { state.button.prop('disabled', state.disabled)[state.method](state.label); });
      delete form.dataset.nativeCartPending; form.removeAttribute('aria-busy');
      $formEl.removeClass('add-in-progress');
    }
    $formEl.find('.cart-drawer__form-error').remove();
    add(body, { open: true }).then(function () {
      controls.forEach(function (state) { state.button[state.method](theme.strings.addedToCart); });
      setTimeout(restore, 1000);
      if (theme.settings && theme.settings.onAddToCart === 'add_and_redirect') window.location = theme.routes.cart_url;
    }).catch(function (err) {
      $formEl.find(':submit').first().after('<div class="cart-drawer__form-error">' + escapeHtml(err.description || err.message || '') + '</div>');
      restore();
    });
  }

  // theme.js assigns theme.initAjaxAddToCartForm after this file runs (this
  // script is loaded before theme.js on purpose). A setter keeps our version in
  // place no matter who assigns it later.
  function overrideAjaxAddToCart() {
    if (!$) return;
    try {
      Object.defineProperty(theme, 'initAjaxAddToCartForm', {
        configurable: true,
        enumerable: true,
        get: function () {
          return ajaxAddToCartForm;
        },
        set: function () {
          /* theme.js's original handler is intentionally ignored */
        },
      });
    } catch (e) {
      theme.initAjaxAddToCartForm = ajaxAddToCartForm;
    }
  }

  // Fallback: if a form was bound by theme.js's original handler before we
  // could intercept, swap that handler for ours in place (keeps handler order
  // so analytics listeners still see the prevented default).
  function rebindExistingForms() {
    if (!$ || !$._data) return;
    $('form.ajax-product-form').each(function () {
      var form = this;
      var events = $._data(form, 'events');
      var submit = events && events.submit ? events.submit : [];
      var replaced = false;
      submit.forEach(function (handleObj) {
        var src = String(handleObj.handler);
        if (handleObj.handler !== onAjaxFormSubmit && /add-in-progress/.test(src) && /cart_add_url/.test(src)) {
          handleObj.handler = onAjaxFormSubmit;
          replaced = true;
        }
      });
      if (replaced) form.dataset.cartDrawerBound = 'true';
      else if (!submit.some(function (handler) { return handler.handler === onAjaxFormSubmit; })) ajaxAddToCartForm($(form));
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      var drawer = getDrawer();
      if (!drawer) return;
      var mount = drawer.querySelector('[data-caffeine-recommendations][data-placement="cart_drawer"]');
      var rail = drawer.querySelector('[data-cart-upsells]');
      if (mount && rail && (mount.children.length > 0 || mount.dataset.caffeineReady)) rail.hidden = true;
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('fh:surface:opening', onSurfaceOpening);
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('caffeine:cart:open', reportMiniOffersShown);
  document.addEventListener('caffeine:cart:changed', reportMiniOffersShown);
  document.addEventListener('input', onDocumentInput);
  document.addEventListener('change', onDocumentChange);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('submit', onCheckoutSubmit);
  document.addEventListener('submit', onNativeProductSubmit, true);

  // Searchanise owns this POST. Its documented success event only needs a read
  // and drawer handoff; never add the product again or duplicate its analytics.
  // https://docs.searchanise.io/js-api-events/#searchaniseaddtocartsuccess
  var searchaniseRefreshScheduled = false;
  $(document).on('Searchanise.AddToCartSuccess.fatheadCart', function () {
    if (!getDrawer() || theme.settings.onAddToCart !== 'ajax' || searchaniseRefreshScheduled) return;
    searchaniseRefreshScheduled = true;
    Promise.resolve().then(function () {
      searchaniseRefreshScheduled = false;
      try {
        if (window.Searchanise && typeof window.Searchanise.AutocompleteClose === 'function') window.Searchanise.AutocompleteClose();
      } catch (_) {}
      return refresh({ open: true, source: 'searchanise' });
    }).catch(function () {
      cartReviewRequired = true;
      showCartNotice('Your item was added, but the cart could not refresh. Review your cart before checkout.');
    });
  });

  document.addEventListener('theme:cart:added', function (event) {
    var detail = event.detail || {};
    refresh({ open: detail.open !== false }).catch(function () { showCartNotice('We could not refresh your cart.'); });
  });

  document.addEventListener('caffeine:cart:external-change', function (event) {
    var detail = event.detail || {};
    refresh({ open: isOpen(), source: 'external', cart: detail.cart }).catch(function () { showCartNotice('We could not refresh your cart.'); });
  });

  overrideAjaxAddToCart();
  ensureOnBody();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rebindExistingForms();
      setTimeout(rebindExistingForms, 0);
    });
  } else {
    rebindExistingForms();
  }
  window.addEventListener('load', rebindExistingForms);
  // A back/forward restoration can contain pre-add Liquid even when Shopify's
  // cart has changed. Reconcile with reads only; never replay a previous write.
  window.addEventListener('pageshow', function (event) {
    var navigation = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
    if (!event.persisted && (!navigation || navigation.type !== 'back_forward')) return;
    var needsReview = cartReviewRequired;
    cartReviewRequired = true;
    checkoutPending = true;
    setCheckoutBusy(true);
    refresh({ open: isOpen(), source: 'history_restore' }).then(function () {
      cartReviewRequired = needsReview;
    }).catch(function () {
      showCartNotice('We could not refresh your saved cart. Review your cart before checkout.', { open: isOpen() });
    }).finally(function () {
      checkoutPending = false;
      setCheckoutBusy(false);
    });
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(rebindExistingForms, 0);
  });

  // Versioned producer contract: rejection never means "try another POST".
  window.FatheadCart = Object.freeze({
    version: 1, add: addConfirmed, open: open, close: close, refresh: refresh,
    notice: showCartNotice, idle: controller.idle
  });

  theme.cartDrawer = {
    open: open,
    close: close,
    isOpen: isOpen,
    refresh: refresh,
    add: add,
    change: change,
    updateNote: updateNote,
    controller: controller,
  };
})();
